import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/banners`

    return {
        datatable: (queryParms = {}) => {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        create: (queryParms = {}) => {
            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        store: params => {
            return repository.post(`${baseUrl}`, params)
        },
        show: id => {
            return repository.get(`${baseUrl}/${id}`)
        },
        edit: id => {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update: (id, params) => {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy: id => {
            return repository.delete(`${baseUrl}/${id}`)
        },


    }
}
